<div class="fx-bonus-setting card bg-dark-lighter text-white">
  <div class="card-header">
    {{ 'Promotion Code Bonus Settings' | uppercase }}
  </div>
  <div class="card-body">
    <form class="form form-horizontal" #formSetting="ngForm" (ngSubmit)="saveSetting()">
      <div class="row mb-20">
        <div class="col-lg-2 col-12  fs-18 font-bold"> Campaign Name</div>
        <div class="col-lg-10 col-12">
          <div class="row">
            <div class="col-lg-6 col-12">
              <input
                class="w-100 with-placeholder inp-filled" type="text"
                placeholder="Affiliate link Name"
                name="affiliateName"
                [(ngModel)]="bonus.name"
                required>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-20 mt-5">
        <div class="col-lg-2 col-12  fs-18 font-bold mb-3"> Campaign Date</div>
        <div class="col-lg-10 col-12 mb-3">
          <div class="d-flex">
            <div class="section-holder">
              <span class="text sub-label">Start Time</span>
              <p-calendar
                [(ngModel)]="bonus.start_time"
                name="start_time"
                [placeholder]="'dd/mm/yyyy HH:mm'"
                [dateFormat]="'dd/mm/yy'"
                [showIcon]="true"
                [showTime]="true"

                inputStyleClass="form-control bg-dark"
                required
              ></p-calendar>
            </div>
            <div class="section-holder ms-5">
              <span class="text sub-label">End Time</span>
              <p-calendar
                [(ngModel)]="bonus.end_time"
                name="end_time"
                [placeholder]="'dd/mm/yyyy HH:mm'"
                [dateFormat]="'dd/mm/yy'"
                [showIcon]="true"
                [showTime]="true"

                inputStyleClass="form-control bg-dark"
                required
              ></p-calendar>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-20">
        <div class="col-lg-2 m-auto col-12 fs-18 font-bold" style="padding-bottom: 21.5px;">Target Person</div>
        <div class="col-lg-10 col-12">
          <div class="row">
            <div class="col-lg-6 col-12">
              <mat-form-field class="w-100 selector" appearance="outline">
                <mat-label>Username</mat-label>
                <input
                  type="text"
                  placeholder="Pick one"
                  aria-label="Number"
                  matInput
                  [formControl]="targetControl"
                  [matAutocomplete]="auto"
                  (ngModelChange)="onSelectData($event)"
                >
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                  <mat-option *ngFor="let option of listTarget" [value]="option">
                    {{option.email}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-20">
        <div class="col-lg-2 col-12 fs-18 font-bold" style="padding-bottom: 21.5px;">Bonus On Open Account</div>
        <div class="col-lg-10 col-12">
          <div class="row">
            <div class="col-lg col-12">
              <span class="me-1">OFF</span>
              <mat-slide-toggle
                class="red text-green"
                [checked]="bonus.is_enable_account"
                (change)="bonus.is_enable_account = $event.checked"
              >ON
              </mat-slide-toggle>
              <div class="mt-4 d-flex" *ngIf="bonus.is_enable_account">
                <div class="section-holder mb-4 col-2">
                  <span class="text sub-label">Bonus JPY</span>
                  <input
                    type="number"
                    name="bonusJPY"
                    class="extent with-placeholder sub-bonus-inp text-center"
                    placeholder="ex:1000"
                    [(ngModel)]="bonus.data.open_account.jpy_bonus"
                    numberOnly
                    autocomplete="off"
                    required/>
                  <span class="ms-1"></span>
                </div>
                <div class="section-holder mb-4 col-2">
                  <span class="text sub-label">Bonus USD</span>
                  <input
                    type="number"
                    name="bonusUSD"
                    class="extent with-placeholder sub-bonus-inp"
                    placeholder="ex:100"
                    autocomplete="off"
                    [(ngModel)]="bonus.data.open_account.usd_bonus"
                    required/>
                  <span class="ms-1"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-20">
        <!-- <div class="col-lg-2 col-12  fs-18 font-bold">Method</div> -->

        <div class="col-lg-2 m-auto col-12 fs-18 font-bold" style="padding-bottom: 21.5px;">Bonus On Deposit</div>
        <div class="col-lg-10 col-12">
          <div class="row">
            <div class="col-lg-10 col-12">
              <span class="me-1">OFF</span>
              <mat-slide-toggle class="red text-green" [checked]="bonus.is_enable_deposit"
                                (change)="bonus.is_enable_deposit = $event.checked">ON
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-20 conditions" *ngIf="bonus.is_enable_deposit">
        <ng-container *ngFor="let con of bonus.data.deposit.conditions; let i = index">
          <div class="col-lg-2 m-auto col-12 fs-18 font-bold" style="padding-bottom: 21.5px;">Condition {{i + 1}}</div>
          <div class="col-lg-10 col-12">
            <div class="mt-4 d-flex">
              <div class="col">
                <input class="extent with-placeholder text-center" type="text" numberOnly name="_threshold{{i}}"
                       placeholder="ex: 100" (keyup)="onUpdateRateUJ('conditions', i)" [(ngModel)]="con.threshold"/>
                <span class="m-1 sub-label">JPY</span>
                <input type="number" class="extent ms-3 with-placeholder" name="view_threshold{{i}}" placeholder="ex: 100"
                       [disabled]="true" [value]="viewBonus.conditions[i].threshold"/>
                <span class="m-1 sub-label">USD</span>
                <input class="ms-3  with-placeholder" type="number" [(ngModel)]="con.rate" placeholder="ex: 10"
                       name="_rate{{i}}"/>
                <span class="ms-1 sub-label">%</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="row mb-20 {{!bonus.is_enable_account ? ' mt-3' : ''}}" *ngIf="bonus.is_enable_deposit">
        <div class="col-lg-2 col-12  fs-18 font-bold">Upper Limit</div>
        <div class="col-lg-10 col-12">
          <div class="d-flex">
            <div class="col-2">
              <input class="extent with-placeholder sub-bonus-inp text-center" type="number" name="bonusLimit" placeholder="ex:10"
                     autocomplete="off" (keyup)="onUpdateRateUJ('up_limit_usd', 0)" [(ngModel)]="bonus.data.deposit.up_limit"
                     required numberOnly/>
              <span class="ms-1 sub-label">JPY</span>
            </div>
            <div class="col-2">
              <input type="number" name="bonusLimitUSD" class="extent sub-bonus-inp with-placeholder text-center" autocomplete="off"
                     placeholder="ex:10" [disabled]="true" [value]="viewBonus.up_limit_usd" required/>
              <span class="ms-1 sub-label">USD</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row mb-20 conditions" *ngIf="bonus.is_enable_deposit">
        <div class="col-lg-2 col-12  fs-18 font-bold">Amount Conditions</div>
        <div class="col-lg-10 col-12">
          <div class="row mb-2" *ngFor="let con of bonus.data.deposit.conditions; let i = index">
            <div class="col-auto">
              <div class="label">Condition {{i + 1}}</div>
            </div>
            <div class="col">
              <input
                class="extent with-placeholder text-center"
                type="text"
                numberOnly
                name="_threshold{{i}}"
                placeholder="ex: 100"
                (keyup)="onUpdateRateUJ('conditions', i)"
                [(ngModel)]="con.threshold"
              />
              <span class="m-1 sub-label">JPY</span>
              <input
                type="number"
                class="extent ms-3 with-placeholder"
                name="view_threshold{{i}}"
                placeholder="ex: 100"
                [disabled]="true"
                [value]="viewBonus.conditions[i].threshold"
              />
              <span class="m-1 sub-label">USD</span>
              <input
                class="ms-3  with-placeholder"
                type="number"
                [(ngModel)]="con.rate"
                placeholder="ex: 10"
                name="_rate{{i}}"
              />
              <span class="ms-1 sub-label">%</span>
            </div>
          </div>
        </div>
      </div> -->
      <ng-container *ngIf="bonus.is_enable_deposit">
        <div class="row mb-20">
          <div class="col-lg-2 col-12  fs-18 font-bold">Multiple</div>
          <div class="col-lg-10 col-12">
            <span class="me-1">OFF</span>
            <mat-slide-toggle
              class="red text-green"
              [checked]="bonus.data.deposit.multiple_time"
              (change)="bonus.data.deposit.multiple_time = $event.checked"
            >ON
            </mat-slide-toggle>
          </div>
        </div>
        <div class="row mb-20">
          <div class="col-lg-2 col-12  fs-18 font-bold">Bonus Timeout</div>
          <div class="col-lg-10 col-12">
            <select class="selector" name="dfw" [(ngModel)]="bonus.data.deposit.dfw">
              <option *ngFor="let t of timeoutSelector()">{{t}}</option>
            </select>
          </div>
        </div>
        <div class="row mb-20">
          <div class="col-lg-2 col-12  fs-18 font-bold">Bonus Type</div>
          <div class="col-lg-10 col-12">
            <select class="selector" name="nonusType" [(ngModel)]="bonus.data.bonus_type">
              <option [ngValue]="0">Normal</option>
              <option [ngValue]="1">Before</option>
              <option [ngValue]="2">After</option>
            </select>
          </div>
        </div>
      </ng-container>
      <div class="accent-color">
        <mat-checkbox
          color="primary"
          [checked]="sendMail"
          (change)="sendMail = $event.checked;"
        >Send notification emails to target user and all users under target user
        </mat-checkbox>
      </div>
      <div class="preview-mail-btn" (click)="showPreviewOnCreate()">Preview email</div>
      <hr edit-permission/>
      <div class="row">
        <div class="col-lg-12 col-xs-12" edit-permission>
          <button type="submit" class="btn btn-main pull-right btn-bonus-apply">Apply</button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="mt-4">
  <fx-bonus-code-history [loadData]="requestLoadHistory"></fx-bonus-code-history>
</div>

<ng-template #previewMailOnCreate>
  <div class="bonus-popup">
    <div class="close">
      <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div mat-dialog-title class="pop-header d-flex justify-content-center">

    </div>
    <style>
      .pop-body {
        margin: auto;
        width: 800px;
        max-width: calc(100% - 2rem);
        color: #000;
      }
    </style>
    <div mat-dialog-content class="pop-body">
      <!-- template new campaign -->
      <style>
        .popup-logo {
          max-width: 200px;
        }

        .header-logo {
          padding: 12px 0;
          background-color: #000;
          text-align: center;
        }

        .body-banner {
          width: 100%;
        }
      </style>
      <div class="header-logo">
        <img class="popup-logo" src="assets/images/logo.png" alt="">
      </div>
      <img class="body-banner" src="assets/images/images/bonus_mail_preview_header.png" alt="">
      <div class="pop-body-container" contenteditable>
        <style>
          .pop-body-header {
            font-weight: bold;
            font-size: 20px;
            text-align: center;
          }

          .detail-box * {
            color: inherit;
          }

          .detail-box {
            background: #EDEDED;
            margin-top: 24px;
            border-radius: 16px;
            padding: 16px 32px;
            color: #000;
          }

          .detail-box-header {
            text-align: center;
            font-size: 24px;
            color: #EE6E84 !important;
            font-weight: bold;
          }

          ul {
            padding-left: 12px;
          }

          ul.ots {
            padding-left: 24px;
            list-style-type: disc !important;
          }

          .order-list {
            counter-reset: custom-order-list;
          }

          .order-list .order-list-item {
            padding-left: 40px;
            position: relative;
            margin: 24px 0;
          }

          .order-list .order-list-item:first-child {
            margin-top: 0;
          }

          .order-list .order-list-item:before {
            counter-increment: custom-order-list;
            content: counter(custom-order-list);
            position: absolute;
            left: 0;
            top: 0;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: #7c7c7c;
            color: #fff;
            font-weight: bold;
            font-size: 14px;
          }

          .pop-body-container {
            background: #fff;
            padding: 24px;
          }
        </style>
        <div class="pop-body-header">Exciting New Campaign Alert <br> Earn Instant Bonuses on Account Opening and Deposits!</div>
        <br>
        <div class="po-title">
          Dear Valued User, <br><br>
          We're thrilled to announce the launch of our latest campaign that's designed exclusively for you!
          Get ready to enjoy an influx of bonuses as we introduce our {{bonus.name}} campaign.
          Brace yourself for an opportunity to earn rewards like never before!
          <br>
          <div class="detail-box">
            <div class="detail-box-header">Campaign Highlights:</div>
            <br>
            Campaign Duration: <b>/%campaign start date%/</b> - <b>%/campaign end date%/</b>
            <br>
            <br>
            Method: %/OpenAccount =on/% Open Account bonus %/OpenAccount & Deposit =on/% and %/Deposit =on/% Deposit bonus
            <br>
          </div>
          <div class="detail-box">
            <div class="detail-box-header">Campaign Details</div>
            <br>
            <ul>
              <li>
                %/OpenAccount =on/% Open an Account Bonus: For every new account you open during the campaign period, you will receive an exciting bonus of %/bonus amount-yen/% YEN or %/bonus amount-usd/% USD, credited instantly to your account upon successful account creation.
                <br>
              </li>
              <li>
                %/Deposit =on/% /%Multiple =on/% Deposit Delight: Boost your earnings by making multiple deposits during the campaign period.
                Each deposit should be at least %/condition 1-yen/% YEN or %/condition 1-usd/% USD to qualify for this generous bonus with unlimited earning potential: there's no cap on how much you can earn! The more you deposit, the more you'll be rewarded. Earn up to a whopping %/upper limit-yen/% YEN or %/upper limit-usd} USD as your total bonus reward.
              </li>
              <li>
                 %/Deposit =on/%  %/Multiple =off/% Deposit Delight: Boost your earnings by making deposit during the campaign period.
                The deposit should be at least  %/condition 1-yen/%  YEN or  %/condition 1-usd/%  USD to qualify for this generous bonus.
                The more you deposit, the more you'll be rewarded.
                Earn up to a whopping  %/upper limit-yen/%  YEN or  %/upper limit-usd/%  USD as your bonus reward.
              </li>
            </ul>
          </div>
          <div class="detail-box">
            <div class="detail-box-header">How to Participate
            </div>
            <br>
            <div class="order-list">
              <div class="order-list-item">
                <a href="https://my.cryptograph.finance/auth/login">Log in</a> to your account
              </div>
              <div class="order-list-item">
                Head to section “Enter Promotion Code” in menu “Account”, apply this code %/campaign promotion code/% to any of your trading account.
              </div>
              <div class="order-list-item">%/OpenAccount =on/% Open a new trading account.</div>
              <div class="order-list-item">%/OpenAccount =on/% Watch your bonus credited instantly to your account.</div>
              <div class="order-list-item">%/Deposit =on/% %/Multiple =on/% Make deposits of at least %/condition 1-yen/% YEN or %/condition 1-usd/% USD for each deposit to unlock your rewards.</div>
              <div class="order-list-item">%/Deposit =on/% %/Multiple =off/% Make deposit of at least %/condition 1-yen/% YEN or %/condition 1-usd/% USD to unlock your rewards.</div>
              <div class="order-list-item">%/Deposit =on/% %/Multiple =on/% Watch your bonus accumulate instantly with each successful deposit.</div>
              <div class="order-list-item">%/Deposit =on/% %/Multiple =off/% Watch your bonus credited instantly with the successful deposit.</div>

            </div>
          </div>
          <div class="detail-box">
            <div class="detail-box-header">Terms and Conditions</div>
            <br>
            <ul>
              <li>There are no complicated conditions to meet! The bonus is straightforward and meant to bring you maximum joy.</li>
              <li>The bonus is credited and will be available in your account instantly.</li>
              <li>All deposits need to be of at least <b>%/condition1/% YEN</b> or <b>%/condition1/% USD</b> to be eligible for the bonus.</li>
              <li>The deposit need to be of at least <b>%/condition1/% YEN</b> or <b>%/condition1/% USD</b> to be eligible for the bonus.</li>
              <li>Remember, the more you deposit, the higher your bonus reward.</li>
              <li>Please note that:
                <ul class="ots">
                  <li>Any deposit made within %/bonus timeout/% day(s) from the last withdrawal, occurring after the campaign start date, will not qualify for the bonus.</li>
                  <li>%/Bonus type =before/% This campaign is exclusively applicable to users who registered before the %/campaign start date/%. Users who register after the %/campaign start date/% will not be eligible for the bonus.</li>
                  <li>%/Bonus type =after/%This campaign is exclusively applicable to users who registered after the %/campaign start date/%. Users who register before the %/campaign start date/% will not be eligible for the bonus.</li>
                </ul>
              </li>

            </ul>
          </div>
          <div class="mt-4">
            Don't miss out on this golden opportunity to supercharge your trading journey with our <b>campaign_name</b> campaign. Start opening accounts and making deposits to unlock a world of rewards!
          </div>
          <div class="mt-4">
            If you have any questions or need assistance, feel free to reach out to our dedicated support team at <a href="support@crytograph.finance">support@crytograph.finance</a>.
          </div>
          <div class="mt-4">Stay tuned for more exciting campaigns, promotions, and updates coming your way. Thank you for being a valued part of our trading community!</div>
          <div class="mt-4">
            Best regards, <br>
            <div style="color: #EE6E84" class="mt-2">CryptoGraph team</div>
          </div>
        </div>
        <br>
        <br>
      </div>
      <style>
        .pop-footer {
          padding: 24px;
          background: #000;
        }

        .pop-footer .popup-logo {
          width: 101px;
        }

      </style>
      <div class="pop-footer">
        <div class="d-flex justify-content-center">
          <img class="popup-logo" src="assets/images/logo.png" alt="">
        </div>
        <div class="text-center mt-3">
          Address: Suite 305, Griffith Corporate Centre, Beachmont, P.O. Box 1510, <br>
          Kingstown, Saint Vincent and the Grenadines. <br>
          URL: <a href="https://cryptograph.finance/">cryptograph.finance</a>
        </div>
        <div class="text-muted text-center mt-2" style="font-size: 11px">
          *This e-mail and attached documents may contain confidential information, and it is strictly prohibited to use, publish, copy, or divert the content by anyone other than the addressee. <br>
          If you receive an erroneously sent email, please notify the sender immediately by replying and deleting the email.
        </div>
      </div>

      <!-- campaign end -->
      <!--<style>
        .popup-logo {
          max-width: 200px;
        }

        .header-logo {
          padding: 12px 0;
          background-color: #000;
          text-align: center;
        }

        .body-banner {
          width: 100%;
        }
      </style>
      <div class="header-logo">
        <img class="popup-logo" src="assets/images/logo.png" alt="">
      </div>
      <img class="body-banner" src="assets/images/images/bonus_mail_preview_header.png" alt="">
      <div class="pop-body-container" contenteditable>
        <style>
          .pop-body-header {
            font-weight: bold;
            font-size: 20px;
            text-align: center;
          }

          .muted-small {
            color: #9E9E9E;
            font-size: 12px;
            text-align: center;
          }
          .detail-box * {
            color: inherit;
          }

          .detail-box {
            background: #EDEDED;
            margin-top: 24px;
            border-radius: 16px;
            padding: 16px 32px;
            color: #000;
          }

          .detail-box-header {
            text-align: center;
            font-size: 24px;
            color: #EE6E84 !important;
            font-weight: bold;
          }

          ul {
            padding-left: 12px;
          }

          ul.ots {
            padding-left: 24px;
            list-style-type: disc !important;
          }

          .order-list {
            counter-reset: custom-order-list;
          }

          .order-list .order-list-item {
            padding-left: 40px;
            position: relative;
            margin: 24px 0;
          }

          .order-list .order-list-item:first-child {
            margin-top: 0;
          }

          .order-list .order-list-item:before {
            counter-increment: custom-order-list;
            content: counter(custom-order-list);
            position: absolute;
            left: 0;
            top: 0;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: #7c7c7c;
            color: #fff;
            font-weight: bold;
            font-size: 14px;
          }

          .pop-body-container {
            background: #fff;
            padding: 24px;
          }
        </style>
        <div class="pop-body-header">Conclusion of Our Campaign campaign name</div>
        <div class="muted-small">Thank You for Your Participation!</div>
        <br>
        <div class="po-title">
          Dear Valued User, <br><br>
          We hope this message finds you well. We're reaching out to inform you that our recent promotion campaign campaign name has come to an end. We are truly delighted by your enthusiastic participation and the immense support you've shown throughout the campaign period.
          <br>
          <br>
          For those who haven't had the chance to join this campaign, fret not! We have more exciting campaigns lined up in the near future, and we'd be thrilled to have you on board. Your participation means a lot to us, and we can't wait to offer you more opportunities to earn rewards and engage with our platform.
          <br>
          <br>
          While this campaign may have concluded, please rest assured that we are already hard at work planning exciting new campaigns in the coming months. Your continued support means the world to us, and we eagerly look forward to having you join us in our upcoming endeavors.
          <br>
          <br>
          In the meantime, if you have any questions, feedback, or suggestions, please feel free to reach out to our support team at <a href="mailto:support@crytograph.finance">support@crytograph.finance</a>. We value your input and are always here to assist you.
          <br>
          <br>
          Thank you once again for being an essential part of our journey. We couldn't have done it without you. Here's to a future filled with more opportunities, rewards, and growth together!
          <div class="mt-4">
            Best regards, <br>
            <div style="color: #EE6E84" class="mt-2">CryptoGraph team</div>
          </div>
        </div>
        <br>
        <br>
      </div>
      <style>
        .pop-footer {
          padding: 24px;
          background: #000;
        }

        .pop-footer .popup-logo {
          width: 101px;
        }

      </style>
      <div class="pop-footer">
        <div class="d-flex justify-content-center">
          <img class="popup-logo" src="assets/images/logo.png" alt="">
        </div>
        <div class="text-center mt-3">
          Address: Suite 305, Griffith Corporate Centre, Beachmont, P.O. Box 1510, <br>
          Kingstown, Saint Vincent and the Grenadines. <br>
          URL: <a href="https://cryptograph.finance/">cryptograph.finance</a>
        </div>
        <div class="text-muted text-center mt-2" style="font-size: 11px">
          *This e-mail and attached documents may contain confidential information, and it is strictly prohibited to use, publish, copy, or divert the content by anyone other than the addressee. <br>
          If you receive an erroneously sent email, please notify the sender immediately by replying and deleting the email.
        </div>
      </div>-->

      <!-- data change template -->
     <!-- <style>
        .popup-logo {
          max-width: 200px;
        }

        .header-logo {
          padding: 12px 0;
          background-color: #000;
          text-align: center;
        }

        .body-banner {
          width: 100%;
        }
      </style>
      <div class="header-logo">
        <img class="popup-logo" src="assets/images/logo.png" alt="">
      </div>
      <img class="body-banner" src="assets/images/images/bonus_mail_preview_header.png" alt="">
      <div class="pop-body-container" contenteditable>
        <style>
          .pop-body-header {
            font-weight: bold;
            font-size: 20px;
            text-align: center;
          }

          .detail-box * {
            color: inherit;
          }

          .detail-box {
            background: #EDEDED;
            margin-top: 24px;
            border-radius: 16px;
            padding: 16px 32px;
            color: #000;
          }

          .detail-box-header {
            text-align: center;
            font-size: 24px;
            color: #EE6E84 !important;
            font-weight: bold;
          }

          ul {
            padding-left: 12px;
          }

          ul.ots {
            padding-left: 24px;
            list-style-type: disc !important;
          }

          .order-list {
            counter-reset: custom-order-list;
          }

          .order-list .order-list-item {
            padding-left: 40px;
            position: relative;
            margin: 24px 0;
          }

          .order-list .order-list-item:first-child {
            margin-top: 0;
          }

          .order-list .order-list-item:before {
            counter-increment: custom-order-list;
            content: counter(custom-order-list);
            position: absolute;
            left: 0;
            top: 0;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: #7c7c7c;
            color: #fff;
            font-weight: bold;
            font-size: 14px;
          }

          .pop-body-container {
            background: #fff;
            padding: 24px;
          }
        </style>
        <div class="pop-body-header">
          Important Update
          <br>
          Exciting Changes to Our Promotion Campaign!
        </div>
        <br>
        <div class="po-title">
          Dear <b>UserName</b>, <br><br>
          We hope this message finds you well. We wanted to inform you about some exciting changes we've made to our ongoing promotion campaign. Our goal is to provide you with the best possible trading experience, and these updates are designed to make your participation even more rewarding.
          <br>
          <br>
          Here are the key details of the updated campaign (changes are highlighted in orange):
          Campaign Name: <b>campaign Name</b>
          Campaign Start Date: <b>campaign start date</b>
          Campaign End Date: <b>campaign end date</b>
          <br>
          <br>
          %/OpenAccount =on/% Bonus on Open Account Method:
          <ul class="ots">
            <li style="color: #fa6400">Bonus Amount: %/new bonus amount-yen/% YEN or %/new bonus amount-usd/% USD</li>
          </ul>

          %/Deposit =on/%Bonus on Deposit Method:
          <ul class="ots">
            <li>Bonus Amount: upto %/new upper limit-yen/% YEN or %/new upper limit-usd/% USD</li>
            <li>Bonus Conditions: The deposit need to be of at least %/condition 1-yen/% YEN or %/condition 1-usd/% USD to be eligible for the bonus</li>
            <li>%/Multiple =off/% Only the first deposit is eligible for the bonus</li>
            <li>%/Multiple =on/% All the deposits are eligible for the bonus until the total bonus amount reaches %/new upper limit-yen/% YEN or %/new upper limit-usd/% USD</li>
          </ul>
          <div class="detail-box">
            <div class="detail-box-header">Please note that:</div>
            <br>
            <div class="order-list">
              <div class="order-list-item">
                Any deposit made within %/bonus timeout/% day(s) from the last withdrawal, occurring after the campaign start date, will not qualify for the bonus.
              </div>
              <div class="order-list-item">%/Bonus type =before/%This campaign is exclusively applicable to users who registered before the %/campaign start date/%. Users who register after the %/campaign start date/% will not be eligible for the bonus.</div>
              <div class="order-list-item">%/Bonus type =after/%This campaign is exclusively applicable to users who registered after the %/campaign start date/%. Users who register before the %/campaign start date/% will not be eligible for the bonus.</div>

            </div>
          </div>
          <br>
          These changes are effective immediately and will apply to all future participants in the campaign. We believe that these adjustments will provide you with even more opportunities to maximize your earnings and enjoy a better trading experience.
          Please don't hesitate to reach out if you have any questions or need further clarification on these updates. We value your participation and are committed to ensuring that you have the best possible experience with us.
          <br>
          <div class="mt-4">Thank you for choosing us as your trading platform. We look forward to seeing you achieve even greater success in this updated campaign.</div>
          <div class="mt-4">
            Best regards, <br>
            <div style="color: #EE6E84" class="mt-2">CryptoGraph team</div>
          </div>
          <div class="detail-box">
            <div class="detail-box-header">Have you taken part? No? <br>
              Here are the steps on how to participate:
            </div>
            <br>
            <div class="order-list">
              <div class="order-list-item">
                <a href="https://my.cryptograph.finance/auth/login">Log in</a> to your account
              </div>
              <div class="order-list-item">
                Head to section “Enter Promotion Code” in menu “Account”, apply this code %/campaign promotion code/% to any of your trading account.
              </div>
              <div class="order-list-item">%/OpenAccount =on/% Open a new trading account.</div>
              <div class="order-list-item">%/OpenAccount =on/% Watch your bonus credited instantly to your account.</div>
              <div class="order-list-item">%/Deposit =on/% %/Multiple =on/% Make deposits of at least %/condition 1-yen/% YEN or %/condition 1-usd/% USD for each deposit to unlock your rewards.</div>
              <div class="order-list-item">%/Deposit =on/% %/Multiple =off/% Make deposit of at least %/condition 1-yen/% YEN or %/condition 1-usd/% USD to unlock your rewards.</div>
              <div class="order-list-item">%/Deposit =on/% %/Multiple =on/% Watch your bonus accumulate instantly with each successful deposit.</div>
              <div class="order-list-item">%/Deposit =on/% %/Multiple =off/% Watch your bonus credited instantly with the successful deposit.</div>

            </div>
          </div>


        </div>
        <br>
        <br>
      </div>
      <style>
        .pop-footer {
          padding: 24px;
          background: #000;
        }

        .pop-footer .popup-logo {
          width: 101px;
        }

      </style>
      <div class="pop-footer">
        <div class="d-flex justify-content-center">
          <img class="popup-logo" src="assets/images/logo.png" alt="">
        </div>
        <div class="text-center mt-3">
          Address: Suite 305, Griffith Corporate Centre, Beachmont, P.O. Box 1510, <br>
          Kingstown, Saint Vincent and the Grenadines. <br>
          URL: <a href="https://cryptograph.finance/">cryptograph.finance</a>
        </div>
        <div class="text-muted text-center mt-2" style="font-size: 11px">
          *This e-mail and attached documents may contain confidential information, and it is strictly prohibited to use, publish, copy, or divert the content by anyone other than the addressee. <br>
          If you receive an erroneously sent email, please notify the sender immediately by replying and deleting the email.
        </div>
      </div>-->

    </div>
  </div>
</ng-template>
